import type {
  InvestorFundSummary,
  InvestorFundRelationship,
} from '@/types/investor';

// Accept both summary (has fund_name) and relationship (no fund_name) types
type FundItem =
  InvestorFundSummary | (InvestorFundRelationship & { fund_name?: string });

interface FundBadgeListProps {
  funds: FundItem[];
}

export function FundBadgeList({ funds }: FundBadgeListProps) {
  // Handle empty state
  if (!funds || funds.length === 0) {
    return null;
  }

  // Show all funds separated by bullets, filtering out null/undefined fund names
  const fundNames = funds
    .filter((f) => f?.fund_name)
    .map((f) => f.fund_name)
    .join(' • ');

  // Handle case where all fund names were filtered out
  if (!fundNames) {
    return null;
  }

  return (
    <span className="text-sm text-foreground" title={fundNames}>
      {fundNames}
    </span>
  );
}
